var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer",attrs:{"id":"footer"}},[_c('div',{staticClass:"footer-row"},[_c('div',{staticClass:"footer-center"},[_vm._v("\n      "+_vm._s(_vm.copyright)+"\n    ")]),_vm._v(" "),_c('div',{staticClass:"license-text"},[_vm._v("\n      LICENSED: "),_c('span',{staticClass:"license-name"},[_vm._v(_vm._s(_vm.licenseName))])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-48249aeb","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/Footer.vue
// module id = null
// module chunks = 